import fasHiera1 from "./fas-hiera (1).webp";
import fasHiera2 from "./fas-hiera (2).webp";
import fasHiera3 from "./fas-hiera (3).webp";

const fashiera = [fasHiera1, fasHiera2, fasHiera3];

export default fashiera;
